import './scripts/common';


let _config = window['_config'] || {};

let app = {
    debug: false,
};
window.app = app || {};


/**********************************
 *
 *      Site Stuff
 *
 * ********************************/
import {onFind} from "@elements/init-modules-in-scope";

import 'bootstrap/js/dist/dropdown';

import * as ajaxForm from '@elements/ajax-form';
ajaxForm.init();

import * as ajaxFormSubmitOnReset from './scripts/ajax-form-submit-on-reset';
ajaxFormSubmitOnReset.init();

import * as floatingLabels from '@elements/floating-labels';
floatingLabels.init();

import * as scrollingArea from './scripts/scrolling-area';
scrollingArea.init();

import * as dropdownPersist from './scripts/dropdown-persist';
dropdownPersist.init();

import * as multipleSelectDropdown from './scripts/multiselect-dropdown';
multipleSelectDropdown.init();

import * as locationMapLeaflet from './scripts/location-map-leaflet';
locationMapLeaflet.init();

import * as ajaxFormExtend from './scripts/ajax-form-extend';
ajaxFormExtend.init();